import Picker from 'react-mobile-picker'
import ChevronIcon from '../Icons/ChevronRight'
import useDatePicker from './useDatePicker'
import constants from '../../constants'

const DatePicker = ({
  value,
  onChange,
  name,
  minAge = constants.MIN_AGE,
  maxAge = constants.MAX_AGE,
}) => {
  const {
    pickerValue,
    availableMonths,
    availableDays,
    availableYears,
    handleNavigation,
    handlePickerChange,
  } = useDatePicker({ value, onChange, name, minAge, maxAge })

  return (
    <div className="mt-2">
      <Picker
        value={pickerValue}
        onChange={handlePickerChange}
        wheelMode="natural"
        itemHeight={50}
        height={350}
      >
        <div className="flex items-stretch w-full">
          <div className="flex-1 relative">
            <div className="absolute top-0 left-0 right-0 z-10 bg-white py-2 flex justify-center">
              <button
                onClick={() => handleNavigation('day', 'prev')}
                disabled={availableDays.indexOf(pickerValue.day) === 0}
                className={`p-2 -rotate-[90deg] ${availableDays.indexOf(pickerValue.day) === 0 ? 'text-gray-300' : 'text-gray-700'}`}
              >
                <ChevronIcon height={30} width={30} />
              </button>
            </div>
            <Picker.Column name="day">
              {availableDays.map((day) => (
                <Picker.Item key={day} value={day}>
                  {({ selected }) => (
                    <div
                      className={`font-bold ${
                        selected
                          ? 'text-[20px] p-2 rounded-xl border border-[#299D6B]  text-neutral-900 bg-[#E6FAF1] px-4 py-2'
                          : 'text-[#9BB1C8] text-[18px]'
                      }`}
                    >
                      {day}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <div className="absolute bottom-0 left-0 right-0 z-10 bg-white py-2 flex justify-center">
              <button
                onClick={() => handleNavigation('day', 'next')}
                disabled={
                  availableDays.indexOf(pickerValue.day) ===
                  availableDays.length - 1
                }
                className={`p-2 rotate-90 ${availableDays.indexOf(pickerValue.day) === availableDays.length - 1 ? 'text-gray-300' : 'text-gray-700'}`}
              >
                <ChevronIcon height={30} width={30} />
              </button>
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="absolute top-0 left-0 right-0 z-10 bg-white py-2 flex justify-center">
              <button
                onClick={() => handleNavigation('month', 'prev')}
                disabled={
                  availableMonths.findIndex(
                    (m) => m.name === pickerValue.month,
                  ) === 0
                }
                className={`p-2 -rotate-[90deg] ${availableMonths.findIndex((m) => m.name === pickerValue.month) === 0 ? 'text-gray-300' : 'text-gray-700'}`}
              >
                <ChevronIcon height={30} width={30} />
              </button>
            </div>
            <Picker.Column name="month">
              {availableMonths.map((month) => (
                <Picker.Item key={month.value} value={month.name}>
                  {({ selected }) => (
                    <div
                      className={`font-bold ${
                        selected
                          ? 'text-[20px] p-2 rounded-xl border border-[#299D6B] text-neutral-900 bg-[#E6FAF1] px-4 py-2'
                          : 'text-[#9BB1C8] text-[18px]'
                      }`}
                    >
                      {month.name}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <div className="absolute bottom-0 left-0 right-0 z-10 bg-white py-2 flex justify-center">
              <button
                onClick={() => handleNavigation('month', 'next')}
                disabled={
                  availableMonths.findIndex(
                    (m) => m.name === pickerValue.month,
                  ) ===
                  availableMonths.length - 1
                }
                className={`p-2 rotate-90 ${availableMonths.findIndex((m) => m.name === pickerValue.month) === availableMonths.length - 1 ? 'text-gray-300' : 'text-gray-700'}`}
              >
                <ChevronIcon height={30} width={30} />
              </button>
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="absolute top-0 left-0 right-0 z-10 bg-white py-2 flex justify-center">
              <button
                onClick={() => handleNavigation('year', 'prev')}
                disabled={availableYears.indexOf(pickerValue.year) === 0}
                className={`p-2 -rotate-[90deg] ${availableYears.indexOf(pickerValue.year) === 0 ? 'text-gray-300' : 'text-gray-700'}`}
              >
                <ChevronIcon height={30} width={30} />
              </button>
            </div>
            <Picker.Column name="year">
              {availableYears.map((year) => (
                <Picker.Item key={year} value={year}>
                  {({ selected }) => (
                    <div
                      className={`font-bold ${
                        selected
                          ? 'text-[20px] p-2 rounded-xl border border-[#299D6B] text-neutral-900 bg-[#E6FAF1] px-4 py-2'
                          : 'text-[#9BB1C8] text-[18px]'
                      }`}
                    >
                      {year}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <div className="absolute bottom-0 left-0 right-0 z-10 bg-white py-2 flex justify-center">
              <button
                onClick={() => handleNavigation('year', 'next')}
                disabled={
                  availableYears.indexOf(pickerValue.year) ===
                  availableYears.length - 1
                }
                className={`p-2 rotate-90`}
              >
                <ChevronIcon height={30} width={30} color="#5A6774" />
              </button>
            </div>
          </div>
        </div>
      </Picker>
    </div>
  )
}

export default DatePicker
